import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { StyledPasswordSecurityContainer } from './passwordSecurityStyles';
import { EmbersProgressBar } from '../progressBar/progressBar';
import { PROMETHEAN_ERROR_OR_DESTRUCT, PROMETHEAN_SUCCESS_GREEN, PROMETHEAN_ALERT } from '../styles/colors/colors';
import { EmbersStatusIcon } from '../statusIcon/statusIcon';
// Validation helper functions
var hasNumber = function hasNumber(str) {
  return /\d/.test(str);
};
var hasUpperCase = function hasUpperCase(str) {
  return /[A-Z]/g.test(str);
};
var hasLowerCase = function hasLowerCase(str) {
  return /[a-z]/g.test(str);
};
export var PasswordSecurity = function PasswordSecurity(props) {
  var intl = useIntl();
  var className = props.className,
    level = props.level,
    password = props.password,
    callback = props.callback;

  // Password validation
  var getValidationResults = function getValidationResults(_password) {
    return [{
      value: _password.length >= 8,
      content: intl.formatMessage({
        id: 'embers.passwordSecurity.condition.characters',
        defaultMessage: '8 characters or more'
      })
    }, {
      value: hasNumber(_password),
      content: intl.formatMessage({
        id: 'embers.passwordSecurity.condition.number',
        defaultMessage: '1 number'
      })
    }, {
      value: hasLowerCase(_password),
      content: intl.formatMessage({
        id: 'embers.passwordSecurity.condition.lowercase',
        defaultMessage: '1 lowercase letter'
      })
    }, {
      value: hasUpperCase(_password),
      content: intl.formatMessage({
        id: 'embers.passwordSecurity.condition.uppercase',
        defaultMessage: '1 uppercase letter'
      })
    }];
  };
  var _useState = useState(getValidationResults('')),
    _useState2 = _slicedToArray(_useState, 2),
    validationResults = _useState2[0],
    setValidationResults = _useState2[1]; // init value as ''

  // Security level: Weak, Moderate or Strong
  var getLevel = function getLevel(level) {
    return [{
      barColor: PROMETHEAN_ERROR_OR_DESTRUCT,
      current: 1,
      text: intl.formatMessage({
        id: 'embers.passwordSecurity.level.weak',
        defaultMessage: 'Weak'
      })
    }, {
      barColor: PROMETHEAN_ALERT,
      current: 2,
      text: intl.formatMessage({
        id: 'embers.passwordSecurity.level.moderate',
        defaultMessage: 'Moderate'
      })
    }, {
      barColor: PROMETHEAN_SUCCESS_GREEN,
      current: 3,
      text: intl.formatMessage({
        id: 'embers.passwordSecurity.level.strong',
        defaultMessage: 'Strong'
      })
    }].find(function (item) {
      return item.current === level;
    });
  };
  var progressBarProps = level ? getLevel(level) : {
    current: 0
  };

  // When new password comes, update validation results and send to outer component: whether the password matches all minimal requirements
  useEffect(function () {
    var newResults = getValidationResults(password);
    setValidationResults(newResults);
    callback && callback(newResults.every(function (item) {
      return !!item.value;
    }));
  }, [password]);
  var renderItem = function renderItem(success, content, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "EmbersPasswordSecurity-conditionItem",
      style: success ? {
        listStyle: 'none',
        marginLeft: '-20px'
      } : void 0,
      key: "conditionItem-".concat(index)
    }, success ? /*#__PURE__*/React.createElement(EmbersStatusIcon, {
      type: "success",
      size: "small"
    }, content) : content);
  };
  return /*#__PURE__*/React.createElement(StyledPasswordSecurityContainer, {
    className: "EmbersPasswordSecurity".concat(className ? " ".concat(className) : '')
  }, level && /*#__PURE__*/React.createElement(EmbersProgressBar, progressBarProps), /*#__PURE__*/React.createElement("p", {
    className: "EmbersPasswordSecurity-title"
  }, intl.formatMessage({
    id: 'embers.passwordSecurity.title',
    defaultMessage: 'Password must contain:'
  })), /*#__PURE__*/React.createElement("ul", {
    className: "EmbersPasswordSecurity-conditions"
  }, validationResults.map(function (item, index) {
    return renderItem(item.value, item.content, index);
  })));
};